//import React components
import {useAppState} from "../../../../context/state";
import {default as InfoElem} from "./SideControlElement";

//import components


export default function SideControlInfo() {
  const {appState} = useAppState();

  return (
    <div className={"sideControl_info"}>
      <div className={"userInfo"}>
        <div className={"sideControl-heading"}>
          <p className={"h3"}>Brukerprofil</p>
        </div>
        <InfoElem
          className={"userInfo-name"}
          label={"Navn"}
          info={`${appState?.user?.first_name} ${appState?.user?.last_name}`}/>
        <InfoElem
          className={"userInfo-email"}
          label={"E-post"}
          info={appState?.user?.email}/>

        <InfoElem
          className={"userInfo-mobile"}
          label={"Mobilnummer"}
          info={appState?.user?.country_code ?
            `+${appState.user.country_code} ${appState.user.mobile}`
            :
            appState?.user?.mobile || ""}
        />
      </div>
    </div>
  )
}
